
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { denodeify } from "q";


@Component({
    selector: 'validator',
    templateUrl: './validator.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Validator {

    @Input("controlToValiddate") controlToValiddate: string;
    @Input("errorCollection") errorCollection: any[];
    errorMessage: string = "";
    get isControlValid() {
        let isvalid = true;
        if (this.errorCollection != null) {
            //set control to valid..
            if (this.errorCollection[this.controlToValiddate] == null) {
                this.errorMessage = "";
                isvalid = true;
            }
            else { //set control to invalid..
                this.errorMessage = this.errorCollection[this.controlToValiddate][0];
                isvalid = false;
            }
        }
        return isvalid;
    }

}
